<button id="btnSecondary" [ngClass]="{'btn':true,'btn-md':true,'btn-block':isBlock}" (click)="emitRawEvent ? onClick($event) : onClick()"
  [disabled]="disabled" [hidden]="!isButtonVisible" [autofocus]="hasFocus">
  <span *ngIf="textOnly(); else elseBlock" class="mx-auto" [innerHTML]="text | safeHtml"></span>
  <ng-template #elseBlock>
    <span [innerHTML]="text | safeHtml"></span>
  </ng-template>
  <span *ngIf="detail" class="ml-auto" [innerHTML]="detail | safeHtml"></span>
</button>
